import { gql } from "apollo-boost";


export const GET_PACKAGE = gql`
query Points($where: PointWhereInput) {
    points(where: $where) {
      data {
        id
        point
        note
        type
        money
        updatedAt
      }
    }
  }
`